import ServiceBase from '@ekd/portal-connector/dist/Service';

import { createCheckAccessService } from './checkAccess.service';
import { createCheckAccessInternalService } from './checkAccessInternal.service';
import { createCheckAdFreeService } from './checkAdFree.service';
import { createGetSubscriptionService } from './getSubscription.service';

import { ApiUrls } from '@root/common/types/apiUrls';

export function createPaywallService({ service }: { service: ServiceBase<ApiUrls> }) {
  const { checkAccess } = createCheckAccessService({ service });
  const { checkAccessInternal } = createCheckAccessInternalService({ service });
  const { checkAdFree } = createCheckAdFreeService({ service });
  const { getSubscription } = createGetSubscriptionService({ service });

  return {
    checkAccess,
    checkAccessInternal,
    checkAdFree,
    getSubscription,
  };
}
